import { produce } from 'immer';
import { createJSONStorage } from 'zustand/middleware';

import { StoreHelper } from '@helpers';

export interface TranslationsState {
	translations?: Record<string, string>;
}

export const initialTranslationsState: TranslationsState = {
	translations: undefined,
};

interface UseTranslationsStoreOutput extends TranslationsState {
	setState: (state: TranslationsState) => void;
	resetState: (state: TranslationsState) => void;
}

export const useTranslationsStore = StoreHelper.createStore<UseTranslationsStoreOutput>(
	(set) => ({
		...initialTranslationsState,
		setState: function (state: TranslationsState) {
			set(
				produce((currentState: TranslationsState) => ({
					...currentState,
					...state,
				})),
				false,
				'setState'
			);
		},
		resetState: function (state: TranslationsState) {
			set({ ...initialTranslationsState, ...state }, false, 'resetState');
		},
	}),
	{
		name: 'Translations',
		storage: createJSONStorage(() => sessionStorage),
	}
);
